<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="data-list-list-view" class="data-list-container">
<!--        <vs-button radius icon="icon-plus" icon-pack="feather" @click="addAdobeImportPopup = true" class="ml-auto" style="margin-top: -43px;margin-bottom: 15px;"></vs-button>-->

        <div class="flex flex-wrap-reverse items-center pt-4" style="position: relative;z-index: 1;">
            <vs-input class="inputx mx-3" :placeholder="$t('searchBySku')" v-model="sku"/>
            <div class="con-select inputx mx-3">
                <div class="input-select-con">
                    <select v-model="category_id" class="input-select vs-select--input" style="padding: 8.8px;">
                        <option :key="index" :value="item.value" v-for="(item,index) in categories">{{ item.value === 0 ? 'All Category' : item.text }}</option>
                    </select>
                </div>
            </div>
            <vs-input class="inputx mx-3" :placeholder="$t('searchByProductName')" v-model="title"/>
            <div class="con-select inputx mx-3">
                <div class="input-select-con">
                    <select v-model="provider_id" class="input-select vs-select--input" style="padding: 8.8px;">
                        <option :key="index" :value="item.provider_id" v-for="(item,index) in providers">{{ item.provider_id === 0 ? 'All Provider' : item.name }}</option>
                    </select>
                </div>
            </div>
            <div class="con-select inputx mx-3">
                <div class="input-select-con">
                    <select v-model="status" class="input-select vs-select--input" style="padding: 8.8px;">
                        <option :key="index" :value="item.id" v-for="(item,index) in [{id:-1,name:'All Status'}, {id:1,name:'Active'},{id:0,name:'Deactive'}]">{{ item.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <vs-table ref="table"
                  :sst="true"
                  :data="products.items"
        >

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div></div>
                <!-- ITEMS PER PAGE -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" style="position: relative;z-index: 2;">
                    <div
                        class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ products.from }} - {{ products.to }} of {{ products.total }} | Show {{ itemsPerPage }} entries</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                    </div>
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="itemsPerPage=5"><span>5</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=10"><span>10</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=25"><span>25</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50"><span>50</span></vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100"><span>100</span></vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th>{{ $t('id') }}</vs-th>
                <vs-th>{{ $t('sku') }}</vs-th>
                <vs-th>{{ $t('category') }}</vs-th>
                <vs-th>{{ $t('title') }}</vs-th>
                <vs-th>{{ $t('amount') }}</vs-th>
                <vs-th>{{ $t('provider') }}</vs-th>
                <vs-th>{{ $t('status') }}</vs-th>
                <vs-th>{{ $t('action') }}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody ref="table_modal">
                    <tr :data="item" :key="index" v-for="(item,index) in data">
                        <vs-td><p class="id">{{ item.id }}</p></vs-td>
                        <vs-td><p class="name">{{ item.Sku }}</p></vs-td>
                        <vs-td><p class="product-price">{{ item.category_title }}</p></vs-td>
                        <vs-td><p class="product-price">{{ item.FullTitle }}</p></vs-td>
                        <vs-td><p class="product-price">{{ item.Amount }} {{ item.Currency }}</p></vs-td>
                        <vs-td><p class="product-price">{{ item.provider }}</p></vs-td>
                        <vs-td><p class="product-price">{{ item.status ? 'Active' : 'Deactive' }}</p></vs-td>
                        <vs-td>
                            <a @click="getById(item.id)" style="cursor:pointer;">{{ $t('edit') }}</a>
                        </vs-td>
                    </tr>
                </tbody>
            </template>
        </vs-table>
        <div class="con-pagination-table vs-table--pagination" v-if="products.total > itemsPerPage">
            <vs-pagination :key="paginateIndexKey" :total="products.last_page" :max-items="itemsPerPage" :size-array="products.total" v-model="page"></vs-pagination>
        </div>

        <vs-popup  class="holamundo max-w-1000" v-bind:title="'Product '+modalButtonText" :active.sync="addAndEditPopup">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('sku') }} *</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-input class="w-full" disabled="disabled" v-model="editOrAdd.Sku" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('Countries') }} *</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-select multiple v-model="editOrAdd.country_ids" class="w-full select-large">
                        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in countries" class="w-full" />
                    </vs-select>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('category') }}</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <div class="con-select w-full select-large">
                        <div class="input-select-con">
                            <select v-model="editOrAdd.category_id" class="input-select vs-select--input" style="padding: 8.8px;">
                                <option :key="index" :value="item.value" v-for="(item,index) in categories">{{ item.text }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('title') }} *</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-input class="w-full" name="FullTitle" v-model="editOrAdd.FullTitle" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('description') }}</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-textarea name="Description" v-model="editOrAdd.Description" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('royalty') }} *</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-input class="w-full" name="Amount" v-model="editOrAdd.Amount" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('Markup') }} *</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-input class="w-full" name="markup" v-model="editOrAdd.markup" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('image') }}</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <img v-if="editOrAdd.image !== ''" :src="editOrAdd.image" style="max-height: 100px;max-width: 100px;">
                    <br v-if="editOrAdd.image !== ''">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <div class="vs-con-input">
                            <input type="file" name="image" ref="imageChange" @change="imageChange" class="vs-inputx vs-input--input normal" style="border: 1px solid rgba(0, 0, 0, 0.2);">
                        </div>
                    </div>
                </div>
            </div>

            <div class="vx-row mb-6" v-for="input in inputs">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t(input) }}</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-input class="w-full" v-bind:name="input" v-model="editOrAdd[input]" />
                </div>
            </div>

            <div class="vx-row mb-6" v-for="editor in editors">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t(editor) }}</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <quill-editor v-bind:name="editor" v-model="editOrAdd[editor]"></quill-editor>
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>{{ $t('status') }}</span>
                </div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-switch color="success" name="status" v-model="editOrAdd.status"/>
                </div>
            </div>


            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full"></div>
                <div class="vx-col sm:w-4/5 w-full">
                    <vs-button color="success" type="filled" @click="editOrAddUser()">{{ modalButtonText }}</vs-button>
                </div>
            </div>
        </vs-popup>

        <vs-popup class="holamundo max-w-1000" v-bind:title="'Adobe Products Import'" :active.sync="addAdobeImportPopup">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('File') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                        <div class="vs-con-input">
                            <input type="file" name="file" ref="adobeFileChange" @change="adobeFileChange" class="vs-inputx vs-input--input normal" style="border: 1px solid rgba(0, 0, 0, 0.2);">
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button color="success" type="filled" @click="addAdobeProducts()">{{ modalButtonText }}</vs-button>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'

    export default {
        components: {
            quillEditor,
        },
        data() {
            return {
                sku: '',
                title: '',
                category_id: 0,
                countries: [],

                provider_id: 0,
                providers: [],
                status: -1,

                products: [],
                page: 1,
                paginateIndexKey: 1,

                inputs: ['language', 'delivery_time', 'operating_systems', 'license_type', 'users_count', 'devices_count'],
                editors: ['tab_description', 'tab_requirement', 'tab_installation'],
                categories: [],
                locale: this.$i18n.locale,
                userInfo: window.userInfo,
                modalButtonText: this.$t('save'),
                items: [],
                itemsFilters: [],
                addAndEditPopup: false,
                addAndEditPopupAuto: false,
                editAndAddTemplate: {
                    id: 0,
                    category_id: 0,
                    country_ids: [],
                    FullTitle: '',
                    Description: '',
                    Amount: '',
                    markup: '',
                    image: '',
                    imageChange: '',
                    language: null,
                    delivery_time: null,
                    operating_systems: null,
                    license_type: null,
                    users_count: null,
                    devices_count: null,
                    tab_description: null,
                    tab_requirement: null,
                    tab_installation: null,
                    status: false,
                    _method: 'POST'
                },
                editOrAdd: {},

                addAdobeImportPopup: false,
                adobeImportFile: '',


                show: false,
                selected: [],
                itemsPerPage: window.itemsPerPage,
                isMounted: false,
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            }
        },
        methods: {
            getProducts(){
                this.$vs.loading();
                const thisIns = this;
                const params = {
                    length: this.itemsPerPage,
                    page: this.page,
                    token: token,
                    sku: this.sku,
                    title: this.title,
                    category_id: this.category_id,
                    provider_id: this.provider_id,
                    status: this.status,
                };
                const u = new URLSearchParams(params).toString();

                axios.get(apiUrl+'/products?token='+token+'&'+u)
                    .then(function (response) {
                        let data = response.data;
                        if(data.code === 200){
                            thisIns.products = data.data;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.paginateIndexKey++;
                        thisIns.$vs.loading.close();
                    });
            },
            adobeFileChange(){
                this.adobeImportFile = '';
                if (this.$refs.adobeFileChange.files.length > 0) {
                    this.adobeImportFile = this.$refs.adobeFileChange.files[0];
                }
            },
            addAdobeProducts(){
                this.$vs.loading();
                const thisIns = this;
                let sendData = new FormData();
                sendData.append('_method', 'POST');
                sendData.append('file', this.adobeImportFile);

                axios.post(apiUrl+'/products/adobe/import?token='+token, sendData)
                    .then(function (response) {
                        let data = response.data;
                        if(data.code === 200){
                            window.updateMyProfile();
                            thisIns.$refs.adobeFileChange.value = '';
                            thisIns.adobeImportFile = '';
                            thisIns.getProducts();
                            thisIns.addAdobeImportPopup = false;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },

            unlimited(){
                this.editOrAdd.limit = 0;
            },
            imageChange(){
                this.editOrAdd.imageChange = '';
                if (this.$refs.imageChange.files.length > 0) {
                    this.editOrAdd.imageChange = this.$refs.imageChange.files[0];
                }
            },
            getById(id){
                this.modalButtonText = this.$t('save');
                this.$vs.loading();
                this.editOrAdd = JSON.parse(JSON.stringify(this.editAndAddTemplate));
                this.editOrAdd.id = id;
                const thisIns = this;

                // eslint-disable-next-line no-undef
                axios.get(apiUrl+'/products/'+id+'/edit?token='+token)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            for(var index in data.data) {
                                if (data.data.hasOwnProperty(index)) {
                                    thisIns.editOrAdd[index] = data.data[index];
                                }
                            }
                            thisIns.addAndEditPopup = true;
                            thisIns.addAndEditPopupAuto = false;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            editOrAddUser(){
                this.$vs.loading();
                // eslint-disable-next-line no-undef
                let url = apiUrl+'/products?token='+token;
                this.editOrAdd._method = 'POST';
                if(this.editOrAdd.id !== 0){
                    // eslint-disable-next-line no-undef
                    url = apiUrl+'/products/'+this.editOrAdd.id+'?token='+token;
                    this.editOrAdd._method = 'PUT';
                }

                const thisIns = this;
                let sendData = new FormData();

                for(let index in thisIns.editOrAdd) {
                    let value = thisIns.editOrAdd[index];
                    if (index === 'status') {
                        if (value == true || value == '1') value = 1;
                        else value = 0;
                    }
                    if (value === null) value = '';
                    sendData.append(index, value);
                }

                axios.post(url, sendData)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            window.updateMyProfile();
                            thisIns.$refs.imageChange.value = '';
                            thisIns.editOrAdd.imageChange = '';
                            thisIns.getProducts();
                            thisIns.addAndEditPopup = false;
                            thisIns.addAndEditPopupAuto = true;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            }
        },
        created() {
            const thisIns = this;
            // eslint-disable-next-line no-undef
            this.getProducts();
            axios.get(apiUrl + '/countries/getList?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.countries = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });

            axios.get(apiUrl + '/categories/getLast?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.categories = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });

            axios.get(apiUrl + '/providers?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        let pr = {provider_id: 0, name: 'All Provider'};
                        data.data.unshift(pr);
                        thisIns.providers = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });


        },
        mounted() {
            this.isMounted = true;
        },
        watch: {
            addAndEditPopup(state){
                if(!state && !this.addAndEditPopupAuto) {
                    this.addAndEditPopup = true;
                    if(confirm('Close Popup?')) {
                        this.addAndEditPopup = false;
                    }
                }
            },
            sku: function () {
                this.page = 1;
                this.getProducts();
            },
            title: function () {
                this.page = 1;
                this.getProducts();
            },
            category_id: function () {
                this.page = 1;
                this.getProducts();
            },
            provider_id: function () {
                this.page = 1;
                this.getProducts();
            },
            status: function () {
                this.page = 1;
                this.getProducts();
            },
            page: function () {
                this.getProducts();
            },
            itemsPerPage(stage){
                this.page = 1;
                localStorage.setItem('itemsPerPage', stage);
                window.itemsPerPage = stage;
                this.getProducts();
            }
        }
    }
</script>

<style lang="scss">

    .active {

        path {
            fill: #d92121 !important;
        }
    }



    .ui-selected {
        background: rgba(var(--vs-primary), .05) !important;
        color: rgba(var(--vs-primary), 1);
        -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
        box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
    }

    .td-check {
        display: none !important;
    }

    #data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
